import { useMemo, useState } from "react";
import { feedItems, peopleCats } from "@/mocks/gossip";

const cats = ["全部", ...peopleCats];

function FeedCard({ item }: { item: (typeof feedItems)[number] }) {
  return (
    <a href="#feed" className="group flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300">
      <div className="relative aspect-[16/9] w-full overflow-hidden">
        <img
          src={item.img}
          alt={item.title}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-black/5 to-transparent"></div>
        <span className="absolute left-3 top-3 chip bg-background-50/90 px-2.5 py-1 text-[11px] font-medium text-foreground-800">
          {item.cat}
        </span>
        {item.hot && (
          <span className="absolute right-3 top-3 inline-flex items-center gap-1 rounded-full bg-primary-500 px-2 py-1 text-[11px] font-medium text-background-50">
            <i className="ri-fire-fill"></i>热
          </span>
        )}
        <span className="absolute bottom-3 left-3 chip bg-black/40 px-2 py-0.5 text-[11px] text-background-50">
          <i className="ri-hashtag"></i>{item.tag}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
          {item.title}
        </h3>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{item.excerpt}</p>
        <div className="mt-auto flex items-center justify-between border-t border-background-100 pt-3 text-xs text-foreground-400">
          <span className="flex items-center gap-1 text-primary-600">
            <i className="ri-eye-line"></i>
            {item.heat} 围观
          </span>
          <span>{item.time}</span>
        </div>
      </div>
    </a>
  );
}

export default function Feed() {
  const [active, setActive] = useState("全部");
  const list = useMemo(
    () => (active === "全部" ? feedItems : feedItems.filter((f) => f.cat === active)),
    [active],
  );
  const left = list.filter((_, i) => i % 2 === 0);
  const right = list.filter((_, i) => i % 2 !== 0);

  return (
    <section id="feed" className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="flex items-center gap-2">
              <span className="h-6 w-1.5 rounded-full bg-accent-500"></span>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">吃瓜头条</h2>
            </div>
            <p className="mt-2 text-sm text-foreground-500">分门别类追热点，网红 / 明星 / 主播 / 博主 / 人物随时切换</p>
          </div>
          <div className="flex flex-wrap gap-1.5">
            {cats.map((c) => (
              <button
                key={c}
                onClick={() => setActive(c)}
                className={`chip px-3.5 py-1.5 text-xs transition-colors ${
                  active === c
                    ? "bg-secondary-500 text-background-50"
                    : "border border-background-200 bg-background-50 text-foreground-600 hover:border-secondary-400 hover:text-secondary-800"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-2">
          <div className="grid grid-cols-1 content-start gap-5">
            {left.map((item) => (
              <FeedCard key={item.id} item={item} />
            ))}
          </div>
          <div className="grid grid-cols-1 content-start gap-5">
            {right.map((item) => (
              <FeedCard key={item.id} item={item} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}